module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_InvertedBadges_116x116_3-9e351dfa16c721bd8be037f8b1c875e7.png";